import type { AreaGuide } from "./types"
import { BRISTOL_AREA_GUIDES } from "./bristol"
import { BRIGHTON_AREA_GUIDES } from "./brighton"
import { BATH_AREA_GUIDES } from "./bath"
import { OXFORD_AREA_GUIDES } from "./oxford"

export type { AreaGuide }

export const AREA_GUIDES: Record<string, AreaGuide[]> = {
  bristol: BRISTOL_AREA_GUIDES,
  brighton: BRIGHTON_AREA_GUIDES,
  bath: BATH_AREA_GUIDES,
  oxford: OXFORD_AREA_GUIDES,
}

export function getAreaGuide(
  locationSlug: string,
  areaSlug: string
): AreaGuide | undefined {
  return AREA_GUIDES[locationSlug]?.find((a) => a.slug === areaSlug)
}

export function getAreaGuidesForLocation(
  locationSlug: string
): AreaGuide[] {
  return AREA_GUIDES[locationSlug] ?? []
}

export function getAllAreaSlugsForLocation(
  locationSlug: string
): string[] {
  return (AREA_GUIDES[locationSlug] ?? []).map((a) => a.slug)
}
